import axios from 'axios'

const baseURL = process.env.VUE_APP_ROUTE_OPTIMIZATION_BE_URL

const RouteOptimizationRepository = {
  exchangeToken(payload) {
    return axios.post(`${baseURL}/api/token/exchange`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}

export default RouteOptimizationRepository
